import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import $ from 'jquery';
import { footer } from "../../components/footerSize";
import {agreePayNull} from "../../services/patient/action"


class RequestStatus extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            currentDate: "",
            approvalDate: "",
            fetchingDate: "",
            readyDate: "",
            facilityPriorApproval:"Approved"
        }
    }
    componentDidMount() {
        // onDocumentReady function bind
        $(document).ready(function () {
            footer("#content");
        });

        // onResize bind of the function
        $(window).resize(function () {
            footer("#content");
        });

        this.props.agreePayNull();

        let data = this.props.getApiCostDetails
       let facilityPriorApproval = data.approximateCostDTO.facilityPriorApproval
         this.setState({
            facilityPriorApproval 
        })

        if (data.approximateCostDTO) {
            let responseTimeId = data.approximateCostDTO.responseTimeId

             switch (responseTimeId) {
            
         
                case 1:
                    let currentDate = moment().format("MMM Do YY");

                    let approvalDate = moment().format("MMM Do YY");
                    let fetchingDate = moment().format("MMM Do YY");
                    let readyDate = moment().format("MMM Do YY");
                    if(facilityPriorApproval === "Pending"){
                         approvalDate = moment().add(1, 'days').format("MMM Do YY")
                         fetchingDate = moment().add(1, 'days').format("MMM Do YY")
                         readyDate = moment().add(1, 'days').format("MMM Do YY")
                    }
                    this.setState({
                        currentDate,
                        approvalDate,
                        fetchingDate,
                        readyDate
                    })
                    break;

                case 2:
                    currentDate = moment().format("MMM Do YY");
                    approvalDate = moment().add(1, 'days').format("MMM Do YY")
                    fetchingDate = moment().add(2, 'days').format("MMM Do YY")
                    readyDate = moment().add(3, 'days').format("MMM Do YY")
              
                    this.setState({
                        currentDate,
                        approvalDate,
                        fetchingDate,
                        readyDate
                    })
                    break;

                    
                case 3:
                currentDate = moment().format("MMM Do YY");
                approvalDate = moment().add(1, 'days').format("MMM Do YY")
                fetchingDate = moment().add(5, 'days').format("MMM Do YY")
                readyDate = moment().add(10, 'days').format("MMM Do YY")
                this.setState({
                    currentDate,
                    approvalDate,
                    fetchingDate,
                    readyDate
                })
                break;
             
             default:
             break;
            }

        }

    }

    render() {
        console.log("tttttttttttttttt", this.props)
        const {
            currentDate,
            approvalDate,
            fetchingDate,
            readyDate,
            facilityPriorApproval 
            } = this.state
        
        return (
            <>

                <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/PatientHome", }, { "name": "Request Status", "route": "/RequestStatus", }]} />
                <div className="content">
                    <div className="contentSection" id="content">
                        <div className="container-fluid">

                            <div className="bodyContent">

                                <div className="row mt-3">
                                    <div className="payment-block">
                                        <div className="box">
                                            <p>Request has been submitted. We will be in touch as the request makes progress.</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className="flat-prog">
                                        <ul>
                                            <li><div className="pro-bre">Request Submitted</div></li>
                                            {facilityPriorApproval === "Pending" &&
                                             <li><div className="pro-bre">Office Approval</div></li>
                                            }
                                            <li><div className="pro-bre">Fetching Records</div></li>
                                            <li><div className="pro-bre"> Records Ready</div></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row text-center">
                                    <div className="flat-prog">
                                        <ul>
                                            <li><div className="dlabel">{currentDate}</div></li>
                                            {facilityPriorApproval === "Pending" &&
                                            <li><div className="dlabel">{approvalDate}</div></li>
                                            }
                                            <li><div className="dlabel">{fetchingDate}</div></li>
                                            <li><div className="dlabel">{readyDate}</div></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="row text-center">
                                    <p style={{ fontSize: "smaller" }}>Dates shown above are tentative and we will work to produce records for you before the Records ready date</p>
                                </div>

                                <div className="row mt-3 mb-2 text-center">
                                    <NavLink to="/PatientHome">       <button type="button" className="btnDefault">Go to my Home Page</button></NavLink>
                                </div>
                            </div>
                        </div>
                    </div></div>

                <Footer />
            </>
        )
    }
}



const mapStateToProps = state => ({

    loginDetails: state.commonReducer.loginDetails,
    profileDetails: state.commonReducer.profileDetails,
    message: state.patientReducer.message,
    getApiCostDetails: state.patientReducer.getApiCostDetails,
    isCostAgree: state.patientReducer.isCostAgree,


});
const mapDispatchToProps = dispatch => ({
    agreePayNull:  () => dispatch(agreePayNull( ))
  });




export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RequestStatus); 